var _rect, _rect2, _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmbedHeaderIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.25,
    y: 0.25,
    width: 23.5,
    height: 23.5,
    rx: 7.75,
    fill: "#FAFAFA"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.25,
    y: 0.25,
    width: 23.5,
    height: 23.5,
    rx: 7.75,
    stroke: "#E9E9E9",
    strokeWidth: 0.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.25 8.625C8.25 8.83211 8.08211 9 7.875 9C7.66789 9 7.5 8.83211 7.5 8.625C7.5 8.41789 7.66789 8.25 7.875 8.25C8.08211 8.25 8.25 8.41789 8.25 8.625Z",
    fill: "#202123"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9 9C9.20711 9 9.375 8.83211 9.375 8.625C9.375 8.41789 9.20711 8.25 9 8.25C8.79289 8.25 8.625 8.41789 8.625 8.625C8.625 8.83211 8.79289 9 9 9Z",
    fill: "#202123"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.125 9C10.3321 9 10.5 8.83211 10.5 8.625C10.5 8.41789 10.3321 8.25 10.125 8.25C9.91789 8.25 9.75 8.41789 9.75 8.625C9.75 8.83211 9.91789 9 10.125 9Z",
    fill: "#202123"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6 8.25C6 7.42157 6.67157 6.75 7.5 6.75H16.5C17.3284 6.75 18 7.42157 18 8.25V15.75C18 16.5784 17.3284 17.25 16.5 17.25H7.5C6.67157 17.25 6 16.5784 6 15.75V8.25ZM17.25 8.25C17.25 7.83579 16.9142 7.5 16.5 7.5H7.5C7.08579 7.5 6.75 7.83579 6.75 8.25V9.75H17.25V8.25ZM6.75 10.5V15.75C6.75 16.1642 7.08579 16.5 7.5 16.5H16.5C16.9142 16.5 17.25 16.1642 17.25 15.75V10.5H6.75Z",
    fill: "#202123"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M8.07387 11.4261C7.96404 11.3163 7.78596 11.3163 7.67613 11.4261C7.56629 11.536 7.56629 11.714 7.67613 11.8239L8.22725 12.375L7.67613 12.9261C7.56629 13.036 7.56629 13.214 7.67613 13.3239C7.78596 13.4337 7.96404 13.4337 8.07387 13.3239L8.69129 12.7065C8.87435 12.5234 8.87435 12.2266 8.69129 12.0435L8.07387 11.4261Z",
    fill: "#202123"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M9.375 13.2188C9.21967 13.2188 9.09375 13.3447 9.09375 13.5C9.09375 13.6553 9.21967 13.7812 9.375 13.7812H10.125C10.2803 13.7812 10.4062 13.6553 10.4062 13.5C10.4062 13.3447 10.2803 13.2188 10.125 13.2188H9.375Z",
    fill: "#202123"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmbedHeaderIcon);
export default __webpack_public_path__ + "static/media/embedHeaderIcon.610a8a2273a748fc278c3337f13d39b9.svg";
export { ForwardRef as ReactComponent };